var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useEffect } from 'react';
import gsap from 'gsap';
import parse from 'html-react-parser';
import { Button } from '../../components/CtaButtons';
import useViewport from '../../hooks/useViewport';
import './OneColorHero.scss';
export var data = {
    title: 'Experience our financial wellness ecosystem',
    copy: 'Schedule a live demo to see firsthand how Envestnet empowers advisors and financial professionals with the technology, solutions, and intelligence needed to make financial wellness a reality for everyone.',
    cta: {
        label: 'Learn More',
        url: 'https://google.com',
        target: 'window',
    },
    orientation: 'right',
};
var defaultProps = { data: data };
var lightClasses = 'bg-white active:bg-[#8bd3e6] text-[#005f9e]';
var darkClasses = 'bg-[#005f9e] active:bg-[#0074bd] text-white';
var disabledClasses = 'disabled:bg-[#d8dcdb] disabled:text-[#767676]';
var textClasses = 'text-[16px] font-medium leading-normal';
var OneColorHero = function (_a) {
    var _b = _a.data, title = _b.title, copy = _b.copy, orientation = _b.orientation, cta = _b.cta;
    useEffect(function () {
        var tl = gsap.timeline({
            scrollTrigger: {
                trigger: '.one-color-hero-section',
                start: 'top center',
            },
        });
        tl.fromTo(['.one-color-hero-title', '.one-color-hero-text', '.one-color-hero-cta'], {
            opacity: 0,
            duration: 0.5,
            stagger: 0.5,
        }, {
            opacity: 1,
            duration: 0.5,
            stagger: 0.5,
        });
    }, []);
    var visualViewport = useViewport().visualViewport;
    var isMobile = visualViewport.width < 768;
    var isTablet = visualViewport.width < 1024 && visualViewport.width >= 768;
    var isDesktop = visualViewport.width >= 1024;
    var clipPath = useMemo(function () {
        if (orientation === 'left') {
            return "polygon(0 0, 100% 0%, 100% 70%, 0 100%)";
        }
        else {
            return "polygon(0 0, 100% 0%, 100% 100%, 0 86%)";
        }
    }, [orientation]);
    var isValidString = function (stringValue) {
        return typeof stringValue === 'string' && stringValue.length > 0;
    };
    var isCtaActive = useMemo(function () {
        return (typeof cta === 'object' &&
            isValidString(cta.label) &&
            isValidString(cta.url));
    }, [cta]);
    var isCopyActive = useMemo(function () {
        return isValidString(copy);
    }, [cta]);
    return (_jsx("div", __assign({ className: "text-white one-color-hero-section w-full items-center relative snap-center", style: {
            clipPath: clipPath,
            marginBottom: "" + (isDesktop ? "128px" : isTablet ? "80px" : isMobile ? "64px" : ''),
        } }, { children: _jsxs("div", __assign({ className: "one-color-hero-wrapper flex flex-col items-center " }, { children: [_jsx("p", __assign({ className: "one-color-hero-title flex text-center " }, { children: title }), void 0),
                isCopyActive && copy && (_jsx("div", __assign({ className: "one-color-hero-text justify-self-center " }, { children: parse(copy) }), void 0)),
                isCtaActive && (_jsx("div", __assign({ className: "one-color-hero-cta" }, { children: _jsx(Button, __assign({ classes: [
                            'text-enblue-500',
                            'focus:bg-enblue-light',
                            'ArticleButtons_custom',
                            'one-color-hero--cta',
                        ], animate: "animate-white" }, { children: _jsx("a", __assign({ className: "text-enblue-500 h-full w-full", href: cta === null || cta === void 0 ? void 0 : cta.url }, { children: cta === null || cta === void 0 ? void 0 : cta.label }), void 0) }), void 0) }), void 0))] }), void 0) }), void 0));
};
OneColorHero.defaultProps = defaultProps;
export default OneColorHero;
